import { Reducer } from 'redux';
import { update } from '../helpers/immutabilityHelper'
import * as Dtos from '../dtos/Tmd.dtos';
import {
    ACTION_QUILLDOCUMENTIMAGE_LOAD_BY_ID,
    ACTION_QUILLDOCUMENTIMAGE_LOAD_BY_QUILLDOCUMENTID,
    ACTION_QUILLDOCUMENTIMAGE_LOAD_FAILURE,
    ACTION_QUILLDOCUMENTIMAGE_LOAD_SUCCESS,

    ACTION_QUILLDOCUMENTIMAGE_SAVE,
    ACTION_QUILLDOCUMENTIMAGE_SAVE_SUCCESS,
    ACTION_QUILLDOCUMENTIMAGE_SAVE_FAILURE,

    ACTION_QUILLDOCUMENTIMAGE_CREATE,
    ACTION_QUILLDOCUMENTIMAGE_CREATE_SUCCESS,
    ACTION_QUILLDOCUMENTIMAGE_CREATE_FAILURE,

    ACTION_QUILLDOCUMENTIMAGE_CLEAR,
    ACTION_QUILLDOCUMENTIMAGE_FILTER,

    QuillDocumentImageAction
} from '../actions/quillDocumentImage';
import { RequestState } from "../enumerations/RequestState";
import { IRequestState, IFormFilter } from "./index";
import { updateFailureIndexToId } from "../helpers/formErrorHelper";

export interface IQuillDocumentImageState {
    formData: Dtos.QuillDocumentImage | Dtos.QuillDocumentImage[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    validationFailures: Dtos.ResponseError[];
    lookups: Dtos.Lookup[];
    loadState: IRequestState;
    saveState: IRequestState;
    updateState: IRequestState;
    createState: IRequestState;
    formFilter: IFormFilter;
    formFilteredData: Dtos.QuillDocumentImage[];
}

const initialState: IQuillDocumentImageState = {
    formData: undefined,
    formState: undefined,
    formProperties: undefined,
    validationFailures: undefined,
    lookups: undefined,
    loadState: {
        status: RequestState.None
    } as IRequestState,
    saveState: {
        status: RequestState.None
    } as IRequestState,
    updateState: {
        status: RequestState.None
    } as IRequestState,
    createState: {
        status: RequestState.None
    } as IRequestState,
    formFilter: {
        search: "",
        showInActive: false
    },
    formFilteredData: []
};

function loading(state: IQuillDocumentImageState, _isLoading: boolean): IQuillDocumentImageState {
    const newState: IQuillDocumentImageState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function loadSuccess(state: IQuillDocumentImageState,
    formData: Dtos.QuillDocumentImage | Dtos.QuillDocumentImage[],
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[],
    responseStatus: Dtos.ResponseStatus
): IQuillDocumentImageState {
    const newState: IQuillDocumentImageState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        formProperties: {
            $set: formProperties
        },
        lookups: {
            $set: lookups
        },
        loadState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return filter(newState, state.formFilter);
}

function filter(state: IQuillDocumentImageState, formFilter: IFormFilter): IQuillDocumentImageState {

    const lexicalDocument: Dtos.QuillDocumentImage[] | undefined =
        state.formData instanceof Array ?
            state.formData :
            undefined;

    const formFilteredData = lexicalDocument ? lexicalDocument.filter(p => (p.active == true || formFilter.showInActive) &&
        (formFilter.search == "" || p.name.toLowerCase().indexOf(formFilter.search.toLowerCase()) > -1)) : undefined;

    const newState: IQuillDocumentImageState = update(state, {
        formFilter: {
            $set: formFilter
        },
        formFilteredData: {
            $set: formFilteredData
        }
    });

    return newState;
}

function loadFailure(state: IQuillDocumentImageState, responseStatus: Dtos.ResponseStatus): IQuillDocumentImageState {
    const newState: IQuillDocumentImageState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus?.errorCode,
                errorMessage: responseStatus?.message,
                errors: responseStatus?.errors
            } as IRequestState
        }
    });

    return newState;
}

function clear(state: IQuillDocumentImageState, propertiesToClear?: string[]): IQuillDocumentImageState {

    if (!propertiesToClear) {
        let formFilter = state.formFilter;
        const newState: IQuillDocumentImageState = update(initialState, {
            formFilter: {
                $set: formFilter
            }
        });
        return newState;
    }

    let stateModifier: any = {};

    propertiesToClear.forEach(propertyToClear => {
        stateModifier[propertyToClear] = { $set: initialState[propertyToClear] }
    });

    const newState = update(state, stateModifier);

    return newState;
}

function saving(state: IQuillDocumentImageState, _isSaving: boolean): IQuillDocumentImageState {
    const newState: IQuillDocumentImageState = update(state, {
        saveState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function saveSuccess(
    state: IQuillDocumentImageState,
    formData: Dtos.QuillDocumentImage | Dtos.QuillDocumentImage[],
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus
): IQuillDocumentImageState {
    const newState: IQuillDocumentImageState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        saveState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return newState;
}

function saveFailure(state: IQuillDocumentImageState, responseStatus: Dtos.ResponseStatus): IQuillDocumentImageState {
    const newState: IQuillDocumentImageState = update(state, {
        saveState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus?.errorCode,
                errorMessage: responseStatus?.message,
                errors: responseStatus?.errors,
                meta: responseStatus.meta
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, state.formData) : undefined
        }
    });

    return newState;
}

function creating(state: IQuillDocumentImageState, _isCreating: boolean): IQuillDocumentImageState {
    const newState: IQuillDocumentImageState = update(state, {
        createState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function createSuccess(
    state: IQuillDocumentImageState,
    formData: Dtos.QuillDocumentImage,
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[]
): IQuillDocumentImageState {
    const newState: IQuillDocumentImageState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        formProperties: {
            $set: formProperties
        },
        lookups: {
            $set: lookups
        },
        createState: {
            $set: {
                status: RequestState.Success
            } as IRequestState
        }
    });

    return newState;
}

function createFailure(state: IQuillDocumentImageState, responseStatus: Dtos.ResponseStatus): IQuillDocumentImageState {
    const newState: IQuillDocumentImageState = update(state, {
        createState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus?.errorCode,
                errorMessage: responseStatus?.message,
                errors: responseStatus?.errors
            } as IRequestState
        }
    });

    return newState;
}

const QuillDocumentImageReducer: Reducer<IQuillDocumentImageState> = (state: IQuillDocumentImageState = initialState, action: QuillDocumentImageAction) => {
    switch (action.type) {
        case ACTION_QUILLDOCUMENTIMAGE_LOAD_BY_ID:
        case ACTION_QUILLDOCUMENTIMAGE_LOAD_BY_QUILLDOCUMENTID:
            return loading(state, true);
        case ACTION_QUILLDOCUMENTIMAGE_LOAD_SUCCESS:
            return loadSuccess(state, action.formData, action.formState, action.formProperties, action.lookups, action.responseStatus);
        case ACTION_QUILLDOCUMENTIMAGE_LOAD_FAILURE:
            return loadFailure(state, action.responseStatus);
        case ACTION_QUILLDOCUMENTIMAGE_CLEAR:
            return clear(state, action.propertiesToClear);
        case ACTION_QUILLDOCUMENTIMAGE_SAVE:
            return saving(state, true);
        case ACTION_QUILLDOCUMENTIMAGE_SAVE_SUCCESS:
            return saveSuccess(state, action.formData, action.formState, action.responseStatus);
        case ACTION_QUILLDOCUMENTIMAGE_SAVE_FAILURE:
            return saveFailure(state, action.responseStatus);
        case ACTION_QUILLDOCUMENTIMAGE_CREATE:
            return creating(state, true);
        case ACTION_QUILLDOCUMENTIMAGE_CREATE_SUCCESS:
            return createSuccess(state, action.formData, action.formState, action.formProperties, action.lookups);
        case ACTION_QUILLDOCUMENTIMAGE_CREATE_FAILURE:
            return createFailure(state, action.responseStatus);
        case ACTION_QUILLDOCUMENTIMAGE_FILTER:
            return filter(state, action.formFilter);
    }

    return state;
}

export default QuillDocumentImageReducer;